export default __webpack_public_path__ + "static/media/personal4.084c4ce2.jpeg";